<itl-warning-item *ngIf="maxAmountExceeded"> {{ 'validation.warning.maxAmount' | translate }} </itl-warning-item>

<!--Article-->
<itl-detail-item *ngIf="article" [noIcon]="!hasCheckbox && !icon">
  <itl-detail-item-icon>
    <div *ngIf="hasCheckbox" class="checkbox-wrapper" (click)="this.toggleCheckbox()">
      <ion-checkbox [checked]="isChecked" [disabled]="disabled"></ion-checkbox>
    </div>
    <ion-icon *ngIf="icon" [class]="iconColor" [name]="icon"></ion-icon>
  </itl-detail-item-icon>
  <div
    class="bold"
    [ngStyle]="{
    'text-decoration': article.archived ? 'line-through' : 'unset'
  }"
    (click)="this.toggleCheckbox()"
  >
    <span class="article-name">{{ article?.name }}</span>
  </div>
  <!--Quantity-->
  <div [ngClass]="isWizardPage == true ? 'secondary-variant' : 'secondary'" class="bold quantity">
    <ng-content select="[slot=dosage]"></ng-content>
  </div>
  <!--EconomicValue-->
  <!-- TODO: Logik, um aus Artikel economicValue zu ermitteln
  <div *ngIf="article?.economicValue">
    <itl-economic-value-card [economicValue]="article?.economicValue"></itl-economic-value-card>
  </div> -->
  <!--Label-->
  <div class="label-container">
    <ng-content select="[slot=deliveredQuantity]"></ng-content>
    <itl-label *ngIf="labelStatus" class="status-label" [baseColor]="getBaseColor(article)"
      >{{ article?.status | articleStatusPipe }} {{ this.getUnavailableFrom(article?.unavailableFrom) }} {{
      this.getUnavailableTo(article?.unavailableTo) }}</itl-label
    >
    <itl-label *ngIf="labelIsPrivateSale" [labelStyle]="'infoLabel'" [icon]="'alberta-private-sale-order'"
      >{{ 'article.details.isPrivateSale' | translate }}
    </itl-label>
    <itl-label *ngIf="labelNotAutomaticDelivery" [labelStyle]="'infoLabel'" [icon]="'alberta-not-automatic-delivery'"
      >{{ 'article.details.notAutomaticDelivery' | translate }}
    </itl-label>
  </div>
  <!--Cards-->
  <div class="card-container">
    <itl-card [header]="'article.position'| translate" *ngIf="position"> {{ position }} </itl-card>
    <itl-card [header]="'device.articleDescription'| translate">
      {{ article?.description || 'k.A.' }}
    </itl-card>
    <itl-card [header]=" 'article.details.additionalDescription' | translate ">
      {{ article?.additionalDescription || 'k.A.' }}
    </itl-card>
    <itl-card [header]="'order.edit.customerNumber' | translate">
      {{ article?.customerNumber || 'k.A.'}}
    </itl-card>
    <itl-card [header]=" 'directOrder.pcn' | translate "> {{ article?.pcn ? article?.pcn : 'k.A.' }} </itl-card>
    <itl-card [header]=" 'directOrder.manufacturerNumber' | translate ">
      {{ article?.manufacturerNumber || 'k.A.' }}
    </itl-card>
    <ng-content select="[slot=cards]"></ng-content>
  </div>
  <!--AdditionalCards-->
  <div *ngIf="articleExpanded" class="card-container">
    <itl-card *ngIf="article.manufacturer" [header]="'article.details.manufacturer' | translate">
      {{ article.manufacturer }}
    </itl-card>
    <itl-card *ngIf="article?.medicalAidPositionNumber" [header]="'order.edit.medicalAidPositionNumber' | translate">
      {{ article?.medicalAidPositionNumber }}
    </itl-card>
    <itl-card *ngIf="article?.ean" [header]="'order.edit.ean' | translate"> {{ article?.ean }} </itl-card>
    <itl-card *ngIf="article?.size" [header]="'article.details.size' | translate"> {{ article?.size }} </itl-card>
    <ng-content select="[slot=additionalCards]"></ng-content>
  </div>
</itl-detail-item>
